(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["skw-league-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('skw-league-menu')) {
  customElements.define('skw-league-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('toggle', event => {
        if (!(event.target instanceof HTMLDetailsElement) || !event.target.open) return;
        this.querySelectorAll('details[open]').forEach(item => {
          if (item !== event.target) item.open = false;
        });
      }, { capture: true, signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const item = event.target.closest('details[open]');
        if (item) {
          item.open = false;
          item.querySelector('summary').focus();
          event.preventDefault();
        }
      }, { signal });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.querySelectorAll('details[open]').forEach(item => item.open = false);
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
